import axios from "axios";
import config from "../config";
import { ChannelsGridResponse } from "./ResponseModels/ChannelsGridResponse";

export async function GetChannelsGridModel(idPage: string) {
  let response = null;
  response = axios
    .get<ChannelsGridResponse>(config.getChannelsGridEndpoint, {
      params: {
        slug: config.apiToken + "#" + idPage,
      },
    })
    .catch((e) => {
      // TODO manage
      console.error("There was an error!", e);
    });

  return response;
}
